import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { Error } from "../common/Error";
import { CommissionModel } from "../../domain/CommissionModel";
import { Grid } from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { Select } from "@ofqual/portal-components/components/Select";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { commissioningCategoriesService, commissioningTeamService } from "../../services";

export const CommissionDetails: React.FC<{
    sectionProps: SectionProps<CommissionModel>;
}> = ({ sectionProps }) => {
    const { control, errors, editable, lookupTracker } = sectionProps;
    const readOnly: boolean | undefined = editable ? false : true;
    const [CommissioningCategoriesLookup] = useLookup(commissioningCategoriesService);
    const [CommissioningTeamLookup] = useLookup(commissioningTeamService);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="title"
                    rules={{ required: true, maxLength: 255 }}
                    as={
                        <TextField
                            variant="outlined"
                            label="Title"
                            data-test="commission-item-title"
                            fullWidth
                            InputProps={{
                                readOnly: readOnly,
                            }}
                            required
                        />
                    }
                />
                {errors.title?.type === "required" && (
                    <Error data-test="error-title-field-required">Title field is required</Error>
                )}
                {errors.title?.type === "maxLength" && (
                    <Error data-test="error-title-field-max-length">Title must be less than 255 characters</Error>
                )}
            </Grid>

            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="description"
                    rules={{ required: true, maxLength: 1500 }}
                    as={
                        <TextField
                            variant="outlined"
                            label="Description"
                            data-test="commission-item-description"
                            multiline
                            fullWidth
                            InputProps={{
                                readOnly: readOnly,
                            }}
                            required
                        />
                    }
                />
                {errors.description?.type === "required" && (
                    <Error data-test="error-description-field-required">Description field is required</Error>
                )}
                {errors.description?.type === "maxLength" && (
                    <Error data-test="error-description-field-max-length">Description must be less than 1500 characters</Error>
                )}
            </Grid>

            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="commissioningCategories"
                    as={
                        <Select
                            label="Commissioning Categories"
                            data-test="commission-item-CommissioningCategories"
                            selectVariant="multiple"
                            lookupTracker={lookupTracker}
                            readOnly={readOnly}
                        >
                            {CommissioningCategoriesLookup}
                        </Select>
                    }
                />
            </Grid>

            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="assignedCommissioningTeamId"
                    as={
                        <Select
                            label="Commissioning Team"
                            data-test="commission-item-CommissioningTeam"
                            selectVariant="single"
                            lookupTracker={lookupTracker}
                            readOnly={readOnly}
                        >
                            {CommissioningTeamLookup}
                        </Select>
                    }
                />
            </Grid>
        </Grid>
    );
};